import NavBarAdmin from "../../components/Admin/Layout/NavBarAdmin";
import { useEffect } from "react";
import ClientFilesAdminTable from "../../components/Admin/Table/ClientFilesAdminTable";
import SearchBar from "../../components/Admin/Services/SearchBar";
import { useServiceStore } from "../../stores/admin/service";
import { useClientFileStore } from "../../stores/admin/clientFile";
import { getAllCustomers } from "../../services/Api/adminService";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import { showToastError } from "../../services/Toasts/toasts";

const AdminClientFile = () => {
  const { update, searchTerm } = useServiceStore();
  const { clientFiles, setClientFiles } = useClientFileStore();
  const { idPartner } = useParams();

  // Function to display users partner filtered or not
  useEffect(() => {
    if (searchTerm !== "") {
      const filteredRequests = clientFiles.filter((item: any) =>
        item?.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setClientFiles(filteredRequests);
    } else {
      getAllCustomers(Number(idPartner))
        .then((data) => setClientFiles(data))
        .catch(() => showToastError("Une erreur s'est produite"));
      }
  }, [searchTerm, update]);

  return (
    <div className="w-screen h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col justify-start items-start overflow-hidden">
      <Header />
      <div className="w-full flex justify-start items-start">
        <NavBarAdmin />
        <ToastContainer position="top-center" />
        <div className="flex flex-col justify-start items-center w-11/12 h-screen m-auto">
          {/* Header Section avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 my-3 border border-gray-100">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-yellow-trio rounded-xl">
                  <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-700 font-K2D">
                    Liste des dossiers clients <span className="text-yellow-trio">({clientFiles.length})</span>
                  </h1>
                  <p className="text-gray-600 text-md mt-1">
                    Gérez les dossiers clients et leurs missions
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Barre de recherche avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg p-4 mb-3 border border-gray-100">
              <div className="w-80">
                <SearchBar />
              </div>
          </div>

          {/* Table des dossiers clients avec design moderne */}
          <div className="w-11/12 bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden ">
            <ClientFilesAdminTable />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AdminClientFile;
